import React from 'react';
import GroupLightComponent from './configs/LightGroupConfig';

const IntermediarioPagina = () => {
  return (
    <div className="intermediario-container">
      <GroupLightComponent 
        groupIds={[
          "grupo13", 
          "grupo14", 
          "grupo15", 
          "grupo16", 
          "grupo17", 
          "grupo18", 
          "grupo19", 
          "grupo20", 
          "grupo21", 
          "grupo22", 
          "grupo23", 
          "grupo24", 
          "grupo25", 
          "grupo26", 
          "grupo27", 
          "grupo28", 
          "grupo29", 
          "grupo30", 
          "grupo31", 
          "grupo32",
          "grupo33", 
          "grupo34", 
          "grupo35", 
          "grupo36", 
          "grupo37",
          "grupo43", 
          "grupo45",
          "grupo46",
          "grupo47",
          "grupo48",
        ]}
        pageId='2'
      />
    </div>
  );
};

export default IntermediarioPagina;